import { getText } from '../../internal/TextLabels'
import { TransactionSelectFilterTypes } from '../../util/transactionConstants'

const {
  ALL,
  ANNULLED,
  CREDITED,
  DEBIT,
  DEBITED,
  FROZEN,
  PARTLY_CREDITED,
  PARTLY_DEBITED,
  ECOMMERCE,
  MERCHANT_PORTAL,
  MERCHANT_API,
} = TransactionSelectFilterTypes

export const getStatusValues = () => [
  {
    key: 'all',
    value: ALL,
    valueLabel: getText('transactions.filter.showAllStatus'),
  },
  {
    key: 'annulled',
    value: ANNULLED,
    valueLabel: getText('transactions.filter.annulled'),
  },
  {
    key: 'credited',
    value: CREDITED,
    valueLabel: getText('transactions.filter.credited'),
  },
  {
    key: 'debit',
    value: DEBIT,
    valueLabel: getText('transactions.filter.debitable'),
  },
  {
    key: 'debited',
    value: DEBITED,
    valueLabel: getText('transactions.filter.debited'),
  },
  {
    key: 'frozen ',
    value: FROZEN,
    valueLabel: getText('transactions.filter.frozen'),
  },
  {
    key: 'partlyCredited',
    value: PARTLY_CREDITED,
    valueLabel: getText('transactions.filter.partlyCredited'),
  },
  {
    key: 'partlyDebited',
    value: PARTLY_DEBITED,
    valueLabel: getText('transactions.filter.partlyDebited'),
  },
]

export const getChannelValues = () => [
  {
    key: 'all',
    value: ALL,
    valueLabel: getText('transactions.filter.showAllChannels'),
  },
  {
    key: 'eCommerce',
    value: ECOMMERCE,
    valueLabel: getText('transactions.filter.eCommerce'),
  },
  {
    key: 'merchantPortal',
    value: MERCHANT_PORTAL,
    valueLabel: getText('transactions.filter.merchantPortal'),
  },
  {
    key: 'merchantApi',
    value: MERCHANT_API,
    valueLabel: getText('transactions.filter.merchantApi'),
  },
]
